import { Accumulator } from "../accumulator";

export const blockingTimeAccumulator = new Accumulator({
    entryType: "longtask",
    name: "total_blocking_time",
    property: "duration",
});
